import React, { Component } from 'react';

class VideoCallTranscriptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      interpreterBlock: '',
      clientBlock: '',
      interpreterTimeoutId: null,
      clientTimeoutId: null
    };
    this.timeouts = {};
    this.audioContextRef = React.createRef();
    this.processNodeRef = React.createRef();
    this.interpreterRef = React.createRef();
    this.clientRef = React.createRef();
    this.lastTranscripts = {
      client: '',
      interpreter: ''
    };
  }

  componentDidMount() {
    this.setupSocketListeners();
    this.handleTranscriptionToggle();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.transcribeAudio !== this.props.transcribeAudio ||
      prevProps.audioEnabled !== this.props.audioEnabled
    ) {
      this.handleTranscriptionToggle(prevProps);
    }
  }

  handleTranscriptionToggle(prevProps = {}) {
    if (this.props.transcribeAudio && this.props.audioEnabled) {
      this.props.socket.emit('start_recognition', {
        clientId: this.props.clientId,
        sessionToken: this.props.sessionToken,
        interpreterId: this.props.interpreterId,
        requestorId: this.props.userId,
        role: this.props.isUser ? 'client' : 'interpreter'
      });
    } else if (prevProps.transcribeAudio && prevProps.audioEnabled) {
      this.cleanup();
    }
  }

  componentWillUnmount() {
    this.cleanup();
    this.removeSocketListeners();
  }

  // Handler tenuti come reference: 'user-event' e 'interpreter-event' sono ascoltati
  // sullo stesso socket anche da VideoCallPage, quindi off() va sempre passato l'handler.
  handleAudioTextEvent = (res) => {
    if (res['type'] === 'RECEIVE_AUDIO_TEXT') {
      this.updateBlocks(res['text'], res['role']);
    }
  };

  handleRecognitionConfirmation = () => {
    this.setupRecognition();
  };

  setupSocketListeners = () => {
    if (this.props.socket) {
      // Rimuovi prima di aggiungere: senza questo un remount duplica i listener
      // e ogni testo trascritto arriva N volte.
      this.removeSocketListeners();
      this.props.socket.on('user-event', this.handleAudioTextEvent);
      this.props.socket.on('interpreter-event', this.handleAudioTextEvent);
      this.props.socket.on('start_recognition_confirmation', this.handleRecognitionConfirmation);
    }
  };

  removeSocketListeners = () => {
    if (this.props.socket) {
      this.props.socket.off('user-event', this.handleAudioTextEvent);
      this.props.socket.off('interpreter-event', this.handleAudioTextEvent);
      this.props.socket.off('start_recognition_confirmation', this.handleRecognitionConfirmation);
    }
  };

  updateBlocks = (transcript, speaker) => {
    let newStateKey = speaker === 'interpreter' ? 'interpreterBlock' : 'clientBlock';
    let timeoutKey = speaker === 'interpreter' ? 'interpreterTimeoutId' : 'clientTimeoutId';
    let elementRef = speaker === 'interpreter' ? this.interpreterRef : this.clientRef;

    this.setState({ [newStateKey]: transcript }, () => {
      this.scrollToBottom(elementRef);
    });

    if (this.state[timeoutKey]) {
      clearTimeout(this.state[timeoutKey]);
    }

    let timeoutId = setTimeout(() => {
      this.setState({ [newStateKey]: '' });
    }, 5000);

    this.setState({ [timeoutKey]: timeoutId });
  };

  scrollToBottom = (ref) => {
    if (ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  };

  removeBlock = (speaker) => {
    this.setState((prevState) => {
      let updatedBlocks = prevState.blocks.filter((block) => block.speaker !== speaker);
      return { blocks: updatedBlocks };
    });
  };

  setupRecognition = async () => {
    if (this.props.transcribeAudio && this.props.audioEnabled) {
      if (!this.audioContextRef.current) {
        this.audioContextRef.current = new AudioContext({ sampleRate: 16000 });
      }
      const audioTrack = this.props.stream.getAudioTracks()[0];
      await this.audioContextRef.current.audioWorklet.addModule('/audio/audio-processor.js');
      const source = this.audioContextRef.current.createMediaStreamSource(
        new MediaStream([audioTrack])
      );
      if (!this.processNodeRef.current) {
        this.processNodeRef.current = new AudioWorkletNode(
          this.audioContextRef.current,
          'passthrough-processor'
        );
      }
      source.connect(this.processNodeRef.current);
      this.processNodeRef.current.port.onmessage = (event) => {
        const floatAudioData = event.data;
        const int16Buffer = Int16Array.from(floatAudioData, (num) => Math.floor(num * 32767));
        this.props.socket.emit('send_audio_data', {
          audio: int16Buffer,
          clientId: this.props.clientId,
          sessionToken: this.props.sessionToken,
          role: this.props.isUser ? 'client' : 'interpreter'
        });
      };
    }
  };

  cleanup = () => {
    if (this.audioContextRef.current && this.processNodeRef.current) {
      this.audioContextRef.current.close();
      this.processNodeRef.current.disconnect();
      this.audioContextRef.current = null;
      this.processNodeRef.current = null;
      this.props.socket.emit('end_recognition', {
        clientId: this.props.clientId,
        sessionToken: this.props.sessionToken,
        role: this.props.isUser ? 'client' : 'interpreter'
      });
    }

    this.props.socket.emit('end_recognition', {
      clientId: this.props.clientId,
      sessionToken: this.props.sessionToken,
      role: this.props.isUser ? 'client' : 'interpreter'
    });
  };

  render() {
    /*  if (this.props.isUser) { */
    return (
      <div
        className={`${this.props.isFullScreen
          ? 'transcriptions-container-fullscreen'
          : 'transcriptions-container'
          }`}
      >
        <div style={{ display: 'flex', width: '100%' }}>
          {this.state.interpreterBlock && (
            <strong style={{ color: 'white' }}>{this.props.isUser ? 'Interprete:' : 'Tu:'}</strong>
          )}
          <div className="transcription-text interpreter-transcription">
            <span className="transcription" ref={this.interpreterRef}>
              {this.state.interpreterBlock}
            </span>
          </div>
        </div>
        <div style={{ display: 'flex', width: '100%' }}>
          {this.state.clientBlock && (
            <strong style={{ color: 'white' }}>{this.props.isUser ? 'Tu:' : 'Utente:'} </strong>
          )}
          <div className="transcription-text client-transcription">
            <span className="transcription" ref={this.clientRef}>
              {this.state.clientBlock}
            </span>
          </div>
        </div>
      </div>
    );
    /* } else {
      return null;
    } */
  }
}

export default VideoCallTranscriptions;
